import gql from 'graphql-tag';
import {
  useMutation,
  type MutationFunctionOptions,
  type FetchResult,
} from '@apollo/react-hooks';

const UPDATE_RESEARCH_ASSESSMENT = gql`
  mutation ($input: UpdateResearchAssessmentInput!) {
    updateResearchAssessment(input: $input)
  }
`;

export const useUpdateResearchAssessment = (): ((
  options?: MutationFunctionOptions,
) => Promise<FetchResult>) => {
  const [updateResearchAssessment] = useMutation(UPDATE_RESEARCH_ASSESSMENT);
  return updateResearchAssessment;
};
